export var Roles;
(function (Roles) {
    Roles["regularUser"] = "MOBA Regular User";
    Roles["assessor"] = "MOBA Asesor";
    Roles["adminHO"] = "MOBA Admin HO";
    Roles["adminSite"] = "MOBA Admin Site";
    Roles["superUser"] = "MOBA Super User";
})(Roles || (Roles = {}));
